import type { ChallengeApi } from '@mathflat/domain/@entities/Challenge/api'
import type { StudentHistoryApi } from '@mathflat/domain/@entities/StudentHistory/api'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

const challengeApi = {
  getAssignedChallenges: async () => {
    const data = await maxios.get<ChallengeApi.Response.AssignedChallenges>(
      '/lesson-classes/challenges',
    )
    return data
  },

  getAchievements: async (
    studentId: string,
    params: {
      curriculumKey: string
    },
  ) => {
    const { data } = await maxios.get<
      DefaultResponse<StudentHistoryApi.성취도_등급_조회.ConceptChip[]>
    >(`/student-history/achievement/student/${studentId}`, {
      params,
    })

    return data
  },
}

export default challengeApi
